/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const termsEditorCategories = {
	component: {
		layout: {
			label: "componentCategories:layout#label"
		},
		navigation: {
			label: "componentCategories:navigation#label"
		},
		content: {
			label: "componentCategories:content#label"
		},
		form: {
			label: "componentCategories:form#label"
		},
		charts: {
			label: "componentCategories:charts#label"
		},
		logic: {
			label: "componentCategories:logic#label"
		},
		fluentUi: {
			label: "componentCategories:fluentUi#label"
		},
		test: {
			label: "componentCategories:test#label"
		}
	}
};
